import styled from '@emotion/styled';
import MapsUgcIcon from '@mui/icons-material/MapsUgc';
import { colorPrimaryDeepBlue, colorPrimarySeaGreen, zAgentLauncher } from '../styles/tokens';

const LauncherIcon = styled(MapsUgcIcon)`
  font-size: 24px;
  color: #ffffff;
`;

const LauncherButton = styled.button`
  position: fixed;
  bottom: 24px;
  right: 24px;
  z-index: ${zAgentLauncher};
  width: 48px;
  height: 48px;
  border-radius: 50%;
  background: ${colorPrimarySeaGreen};
  border: none;
  box-shadow: 0 3px 10px rgba(0, 0, 0, 0.25), 0 1px 3px rgba(0, 0, 0, 0.15);
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0;
  transition: background-color 0.15s, box-shadow 0.15s;

  &:hover {
    background: #009a8f;
    box-shadow: 0 4px 14px rgba(0, 0, 0, 0.3), 0 2px 4px rgba(0, 0, 0, 0.15);
  }

  &:active {
    background: #008a80;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.15);
  }

  &:focus-visible {
    outline: 2px solid ${colorPrimaryDeepBlue};
    outline-offset: 2px;
  }
`;

interface FloatingLauncherProps {
  onClick: () => void;
}

export function FloatingLauncher({ onClick }: FloatingLauncherProps) {
  return (
    <LauncherButton
      onClick={onClick}
      aria-label="AI アシスタントを開く"
      title="AI アシスタント"
      type="button"
    >
      <LauncherIcon />
    </LauncherButton>
  );
}
